import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faSave, faPlus, faArrowAltCircleRight, faArrowAltCircleLeft, faHexagonNodes, faPlay, faChevronCircleLeft, faLandmark, faWindowRestore } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faCircleDown } from '@fortawesome/free-regular-svg-icons';
import CommonHexagonBadge from '../components/common/CommonHexagonBadge';
import toastService from '../services/toastService';

import {
  formatString,
  Input,
  PageContainer,
  SubSectionTitle,
  ButtonSuccess,
  Button,
  Select,
  StatusBadge,
  FormGroup,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  FormRow,
  Label,
  formatDate,
  InfoBox,
  FormRowFull,
  StepIndicator,
  Step,
  Toggle,
  ToggleInput,
  Divider,
  Card,
  CardTitle,
  fadeIn,
  Modal,
  StepCircle,
  StepLabel,
  Footer,
  ModalContent,
  useGoBack,
  SearchInput
} from '../styles/PageStyles';
import { createKnowledgeBase, getKnowledgeBaseByCode, updateKnowledgeBase } from '../services/knowledgeBaseService';
import { getAllConnectorsByFilter } from '../services/connectorService';
import { getDataSources, updateDataSource, createDataSource } from '../services/dataSourceService';
import { useDropzone } from 'react-dropzone';
import { listFiles, uploadFile } from '../services/fileUploadService';
import { fetchCountByFilter, getEntitiesByPagination } from '../services/entityService';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import Pagination from '../components/common/Pagination';
import { usePermission } from '../context/PermissionContext';

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 4px;
  position: relative;
`;

const ToggleOption = styled.button`
  padding: 6px 14px;
  border: none;
  background: ${props => props.$active ? '#ffffff' : 'transparent'};
  color: ${props => props.$active ? (props.$isLinked ? '#dc2626' : '#3b82f6') : '#6b7280'};
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 1;
  min-width: 80px;
  box-shadow: ${props => props.$active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    color: ${props => props.$active ? (props.$isLinked ? '#dc2626' : '#3b82f6') : '#374151'};
  }
`;


const ToggleSwitch = ({ isLinked, onChange }) => {
  return (
    <ToggleContainer>
      <ToggleOption
        $active={isLinked}
        $isLinked={true}
        onClick={() => onChange(true)}
      >
        Linked
      </ToggleOption>
      <ToggleOption
        $active={!isLinked}
        $isLinked={false}
        onClick={() => onChange(false)}
      >
        Unlinked
      </ToggleOption>
    </ToggleContainer>
  );
};



const KnowledgebaseDetails = () => {
  const { knowledgebaseCode } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [knowledgeBaseDetail, setKnowledgebaseDetail] = useState();
  const [connector, setConnector] = useState();
  const [dataSource, setDataSource] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [activeTab, setActiveTab] = useState('basicDetails');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [maxFiles, setMaxFiles] = useState(1);
  const [maxSize, setMaxSize] = useState(10 * 1024 * 1024); // 10 MB
  const [fileTypes, setFileTypes] = useState(['.pdf', '.png', '.jpg']);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEntityDrawerOpen, setIsEntityDrawerOpen] = useState(false);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedDataSourceIndex, setSelectedDataSourceIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentSetupStep, setCurrentSetupStep] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [newValue, setNewValue] = useState(null);
  const [newKey, setNewKey] = useState(null);
  const [config, setConfig] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entitySearchTerm, setEntitySearchTerm] = useState('');

  const { permissions, permissionEnum, loading } = usePermission();
    
  
  const userAccessPermissions = permissions?.length
    ? permissions
        .filter(ele => ele.component_type === "knowledgebase")
        .map(ele => ele.permission)
    : [];
  
  const itemsPerPage = 10;


  // For COnnector corresponding to DS
  useEffect(() => {
    const fetchConnectors = async () => {
      try {
        let filter = {}
        const response = await getAllConnectorsByFilter(filter, {});
        setConnector(response || []);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchConnectors();
  }, [user]);


  // For KNowledgeBase Current
  useEffect(() => {
    const fetchKnowledgebaseByCode = async () => {
      try {
        const parsedKnowledgebaseCode = (knowledgebaseCode); // Parse entityId as a number

        console.log("FETCHING THE KB BY CODE")
        // let filter = {
        //   "code": parsedKnowledgebaseId
        // }
        const response = await getKnowledgeBaseByCode(parsedKnowledgebaseCode);

        console.log("KB-Responce", response)
        setKnowledgebaseDetail({
          ...response,
          pii_flag: response?.pii_flag ?? false,
        });

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    if (knowledgebaseCode !== 'new') {
      fetchKnowledgebaseByCode();
    } else {
      setKnowledgebaseDetail({
        code: "KB-" + new Date().getTime(),
        name: "",
        description: "",
        company_cd: user.companyCd,
        pii_flag: false,
        data_source: [],
        entities: [],
      });
    }

  }, [knowledgebaseCode, user]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        if (knowledgeBaseDetail?.code) {
          // Call API to fetch files using the knowledgeBaseDetail code
          const response = await listFiles(knowledgeBaseDetail.code, selectedDataSource.code);
          setUploadedFiles(response || []); // Update the uploadedFiles state with the fetched files
        }
      } catch (error) {
        console.error('Error fetching files:', error);
      }
    };

    if (knowledgeBaseDetail && selectedDataSource) {
      fetchFiles();
    }
  }, [selectedDataSource, user]); // Trigger this effect when knowledgeBaseDetail changes


  // For Datasource
  useEffect(() => {
    const fetchDataSourcesWithConnectors = async () => {
      try {
        if (Array.isArray(knowledgeBaseDetail?.data_source) && knowledgeBaseDetail.data_source.length > 0) {
          // Fetch data sources
          const dataSourceResponses = await Promise.all(
            knowledgeBaseDetail.data_source.map((dataSourceName) => {
              const filter = { code: dataSourceName };
              return getDataSources(filter, {});
            })
          );

          // Extract the first record from each data source response
          const fetchedDataSources = dataSourceResponses.map((response) => response[0]).filter(Boolean);

          // Fetch connectors for each data source and add connector details
          const updatedDataSources = await Promise.all(
            fetchedDataSources.map(async (ds) => {
              const connectorResponse = connector.filter((conn) => conn.code === ds.connector);
              const connectorDetails = connectorResponse[0]; // Get the first connector
              return { ...ds, connectorDetails }; // Add connector details to the data source
            })
          );

          // Update the dataSource state with the enriched data sources
          setDataSource(updatedDataSources);
        }
      } catch (error) {
        console.error('Error fetching data sources or connectors:', error);
      }
    };

    fetchDataSourcesWithConnectors();
  }, [knowledgeBaseDetail?.data_source, connector]);

  useEffect(() => {
    
    fetchEntityCount();

    getDataConfig().then(data => {
      setConfig(data)
      setTotalItems(data.totalCount)
    });
  },[])

  useEffect(() => {
  if (!config) return;
  
  fetchPageData(currentPage, config)
    .then(setEntityList)
    .finally(() => {});
}, [currentPage, config]);


  const getDataConfig = async () => {
  const [count1, count2] = await Promise.all([
    fetchEntityCount(),
    fetchDocumentCount()
  ]);
  
  return {
    count1,
    count2,
    totalCount: count1 + count2,
    totalPages: Math.ceil((count1 + count2) / itemsPerPage)
  };
};

const fetchPageData = async (currentPage, config) => {
  const skip = (currentPage - 1) * itemsPerPage;

  if (skip < config.count1) {
    const limit = Math.min(itemsPerPage, config.count1 - skip);
    const data1 = await fetchEntites({ skip, limit, type: "entity" });
    
    if (data1.length < itemsPerPage && skip + data1.length === config.count1) {
      const remainingNeeded = itemsPerPage - data1.length;
      const data2 = await fetchEntites({ skip: 0, limit: remainingNeeded, type: "document" });
      return [...data1, ...data2];
    }
    
    return data1;
  } 
  else {
    const adjustedSkip = skip - config.count1;
    const data2 = await fetchEntites({ skip: adjustedSkip, limit: itemsPerPage , type: "document"});
    return data2;
  }
};
  const filteredEntities = entityList.filter((en, index) => en.name.toLowerCase().includes(entitySearchTerm.toLowerCase()));

  const openDrawer = (ds, index) => {
    if (!ds.data) {
      ds.data = {};
    }
    setSelectedDataSource(ds);
    setSelectedDataSourceIndex(index);
    setIsDrawerOpen(true);
  };


   const fetchEntityCount = async () => {
      try {
        const table_name = "entity"
        const query = {type : "entity"}
        const count = await fetchCountByFilter(table_name, query);
        return count;
      } catch (error) {
        console.log("Error while fetching entity count", error);
      }
    }
  const fetchDocumentCount = async () => {
      try {
        const table_name = "entity"
        const query = {type : "document"}
        const count = await fetchCountByFilter(table_name, query);
        console.log("document count", count)
        return count;
      } catch (error) {
        console.log("Error while fetching entity count", error);
      }
    }

    const fetchEntites = async ({skip, limit, type}) => {
      try {
        const filter = {type};
        const sort = {};
        const query = {skip, limit}
        const response = await getEntitiesByPagination(filter, sort, query);
        return response;
      } catch (error) {
        console.error('Error fetching files:', error);
      }
    };
    

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedDataSource(null);
    setSelectedDataSourceIndex(null);
  };

  const saveDsChanges = async (updatedDataSource, index) => {
    let dataSourceCopy = JSON.parse(JSON.stringify(updatedDataSource));
    delete dataSourceCopy.connectorDetails;
    dataSourceCopy.validated = false;
    try {
      const updateResponse = await updateDataSource(dataSourceCopy);
      if (updateResponse) {
        setDataSource((prevDataSource) => {
          const updatedDataSourceList = [...prevDataSource];
          updatedDataSourceList[index] = { ...updatedDataSource, updated_at: new Date().toLocaleString(), validated: false };
          return updatedDataSourceList;
        });
      }
    } catch (error) {

    }
    closeDrawer();
  };

  const verifyDs = async (updatedDataSource, index) => {
    let dataSourceCopy = JSON.parse(JSON.stringify(updatedDataSource));
    delete dataSourceCopy.connectorDetails;
    dataSourceCopy.validated = true;
    try {
      const updateResponse = await updateDataSource(dataSourceCopy);
      if (updateResponse) {
        setDataSource((prevDataSource) => {
          const updatedDataSourceList = [...prevDataSource];
          updatedDataSourceList[index] = { ...updatedDataSource, updated_at: new Date().toLocaleString(), validated: true };
          return updatedDataSourceList;
        });
      }
    } catch (error) {

    }
    closeDrawer();
  };

  const onDrop = async (acceptedFiles, rejectedFiles) => {
    // Handle rejected files
    if (rejectedFiles.length > 0) {
      rejectedFiles.forEach((file) => {
        if (file.errors.some((err) => err.code === 'file-too-large')) {
          toastService.error(`File "${file.file.name}" exceeds the maximum size of ${maxSize / (1024 * 1024)} MB.`);
        }
        if (file.errors.some((err) => err.code === 'file-invalid-type')) {
          toastService.error(`File "${file.file.name}" is not an allowed type. Allowed types: ${fileTypes.join(', ')}`);
        }
      });
    }

    // Check if adding new files exceeds the maxFiles limit
    if (uploadedFiles.length + acceptedFiles.length > maxFiles) {
      toastService.error(`You can only upload up to ${maxFiles} files.`);
      return;
    }

    // Upload each file and update the uploadedFiles state
    const uploadedFileDetails = [];
    for (const file of acceptedFiles) {
      const fileName = await handleUpload(file);
      if (fileName) {
        selectedDataSource.data.url = fileName?.data?.url;
        setSelectedDataSource({ ...selectedDataSource });
        uploadedFileDetails.push({
          "file_name": file.name,
          "updated_at": new Date().toLocaleString()
        });
      }
    }
    // Update the uploadedFiles state
    setUploadedFiles((prevFiles) => [...prevFiles, ...uploadedFileDetails]);
  };


  const handleUpload = async (file) => {
    if (file) {

      try {
        const response = uploadFile(file, knowledgeBaseDetail.code, selectedDataSource?.code, new Date().getTime());
        return response;

      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles,
    maxSize,
    accept: fileTypes.join(','),
  });

  // ENTITY DRAWER DETAILS
  const openEntityDrawer = (entity, index) => {
    setSelectedEntity(entity);
    setIsEntityDrawerOpen(true);
  };

  const closeEntityDrawer = () => {
    setIsEntityDrawerOpen(false);
    setSelectedEntity(null);
  };
  const linkUnlinkEntity = async (entity) => {
    if (!knowledgeBaseDetail?.entities) {
      knowledgeBaseDetail.entities = [];

    }
    const existingEntity = knowledgeBaseDetail?.entities.find((existingEntity) => existingEntity === entity.name);
    if (existingEntity) {
      knowledgeBaseDetail.entities = knowledgeBaseDetail?.entities.filter((existingEntity) => existingEntity !== entity.name);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
    } else {
      knowledgeBaseDetail.entities.push(entity.name);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
    }
  }

  const checkIfPresent = (code) => {
    if (knowledgeBaseDetail?.entities && knowledgeBaseDetail?.entities.length > 0) {
      const entity = knowledgeBaseDetail?.entities.indexOf(code);
      return (entity > -1) ? true : false;
    }
    return false
  }
  const filteredAttributes = (selectedEntity?.attributes || []).filter((attrib) => {
    return attrib?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
    // return user
  });

  const getAttribType = (type) => {
    switch (type) {
      case 'STR':
        return 'String';
      case 'INT':
        return 'Integer';
      case 'FLOAT':
        return 'Float';
      case 'DATE':
        return 'Date';
      case 'ENTITY':
        return 'Entity';
      default:
        return type;
    }
  }
  // Add New Data Source From Connector Modal
  const openModal = () => {
    const dataSource = {
      "code": "DS-" + new Date().getTime(),
      "name": "",
      "status": "INACTIVE",
      "description": "",
      "connector": "",
    }
    setSelectedDataSource(dataSource);
    setShowModal(true);
  }

  const closeModal = () => {
    setShowModal(false);
  }

  const addDataSource = async (conn) => {
    selectedDataSource.connector = conn.code;
    if (selectedDataSource.name == '') {
      toastService.error("Please enter the name of the data source.");
      return;
    }
    try {
      const response = await createDataSource(selectedDataSource);
      let resp = JSON.parse(JSON.stringify(response));
      resp.connectorDetails = conn;
      dataSource.push(resp);
      setDataSource([...dataSource]);
      knowledgeBaseDetail.data_source.push(resp.code);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
      setSelectedDataSource(null);
    } catch (error) {
      console.error('Error creating data source:', error);

    }
    setShowModal(false);
  }



  // REVIEW and Save Knowledgebase
  const renderEntity = (kbEntityList) => {
    if (kbEntityList && kbEntityList.length > 0) {
      return kbEntityList.map((entity, index) => (
        <span key={index}>
          {entity}
          {index < kbEntityList.length - 1 ? ', ' : ''}
        </span>
      ));
    }
    return "-";
  }
  const getNonConnectorProperties = () => {
    const connectorProperties = selectedDataSource.connectorDetails?.properties || [];
    return Object.keys(selectedDataSource.data || {}).filter(
      (key) => !connectorProperties.includes(key)
    );
  };

  const addCustomProperty = (key, value) => {
    setSelectedDataSource((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [key]: value,
      },
    }));
  };
  const removeCustomProperty = (key) => {
    const updatedData = { ...selectedDataSource.data };
    delete updatedData[key];
    setSelectedDataSource((prev) => ({
      ...prev,
      data: updatedData,
    }));
  };
  const saveKnowledgebase = async () => {
    try {
      if (knowledgeBaseDetail.id) {

        updateKnowledgeBase(knowledgeBaseDetail);
        toastService.success("Knowledgebase updated successfully.");
      } else {
        createKnowledgeBase(knowledgeBaseDetail);
        toastService.success("Knowledgebase created successfully.");

      }
      navigate('/knowledge-base');
    } catch (error) {
      console.error('Error saving knowledgebase:', error);

    }
  }

   const handleToggle = (id, value) => {
    setEntityList(filteredEntities.map(entity => 
      entity.id === id ? { ...entity, isLinked: value } : entity
    ));
  };
  const steps = ['Basic Info', 'Data Sources', 'Entities', 'Validate', 'Review'];
  const goBack = useGoBack();
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        {/* <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {knowledgeBaseDetail?.name ? (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              {knowledgeBaseDetail?.name}
            </span>
          ) : (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              Add Knowledgebase
            </span>
          )}
        </SectionTitle> */}
        <PageHeaderWithInfo
          icon={faLandmark}
          goBack={true}
          title={knowledgeBaseDetail?.name ? knowledgeBaseDetail?.name : "Add Knowledgebase"}
          description="Manage the knowledge sources that power your AI agents. Upload documents, connect to external data sources, and organize information to ensure your agents have access to accurate and up-to-date information."
        >
        </PageHeaderWithInfo>

        <Divider />
        {/* Progress Indicator */}
        <StepIndicator>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepCircle
                active={currentSetupStep === index + 1}
                completed={currentSetupStep > index + 1}
                onClick={() => setCurrentSetupStep(index + 1)}
              >
                {currentSetupStep > index + 1 ? '✓' : index + 1}
              </StepCircle>
              <StepLabel active={currentSetupStep === index + 1}>{step}</StepLabel>
            </Step>
          ))}
        </StepIndicator>

        {/* Step 1: Basic Info */}
        {currentSetupStep === 1 && (
          <>
            <InfoBox>
              Start by defining the basic information about your Knowledgebase. This includes the name, description, PII Flag and any other relevant details that will help you identify and manage your Knowledgebase effectively.
            </InfoBox>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>Name</Label>
                <Input type="text" value={knowledgeBaseDetail?.name || ''} onChange={(e) => setKnowledgebaseDetail({ ...knowledgeBaseDetail, name: e.target.value })} />
              </FormGroup>
              <FormGroup>
                <Label>Mask Personal Data</Label>
                <Toggle>
                  <ToggleInput
                    type="checkbox"
                    checked={knowledgeBaseDetail?.pii_flag === true}
                    onChange={(e) => {
                      setKnowledgebaseDetail({
                        ...knowledgeBaseDetail,
                        pii_flag: e.target.checked, // Update pii_flag instead of status
                      });
                    }}
                  />
                </Toggle>
              </FormGroup>

            </FormRow>
            <FormRowFull>
              <FormGroup>
                <Label>Description</Label>
                <Input type="text" value={knowledgeBaseDetail?.description || ''} onChange={(e) => setKnowledgebaseDetail({ ...knowledgeBaseDetail, description: e.target.value })} />
              </FormGroup>

            </FormRowFull>

          </>
        )}

        {/* Step 2: Sources */}
        {currentSetupStep === 2 && (
          <>
            <InfoBox>
              Register Your Data Sources: Connect your data sources to the Knowledgebase. This step allows you to link various data sources, such as databases, APIs, or files, that will be used to populate the Knowledgebase with relevant information.
            </InfoBox>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>&nbsp;</Label>
                <ButtonSuccess onClick={() => openModal()
                }>
                  <FontAwesomeIcon icon={faPlus} /> Data Source</ButtonSuccess>
              </FormGroup>
            </FormRow>
            {knowledgeBaseDetail?.data_source && (
              <>
                {dataSource.map((ds, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} className={ds.status === "INACTIVE" ? "INACTIVE" : ""}>
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${ds.connector}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {ds.name}</h5>
                        <p>{ds.connectorDetails?.description || ''}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => openDrawer(ds, index)}><FontAwesomeIcon icon={faGear} /> Manage</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}
          </>
        )}

        {/* Step 3: Entities */}
        {currentSetupStep === 3 && (
          <>
            <InfoBox>
              Map Entities to Data Sources: In this step, you will link the entities that you want to associate with your Knowledgebase. This allows you to define the relationships between different data sources and the entities they represent.
            </InfoBox>
            <Divider />
  <PageHeaderWithInfo
          icon={faWindowRestore}
          title="Entity"
          description="The Entity page is designed to manage the knowledge sources and documents that power AI agents."
        >
               <div style={{ display: 'flex', gap: "1rem" }}>
            <SearchInput
              type="text"
              placeholder="Search Entities..."
              value={entitySearchTerm}
              onChange={(e) => setEntitySearchTerm(e.target.value)}
            />
          </div>
          </PageHeaderWithInfo>

            {filteredEntities.map((entity, index) => (
              <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} >
                <CardTitle>
                  <CommonHexagonBadge
                    stroke="stroke-brand-clarity"
                    fill="fill-brand-light"
                    size="size-[50px]"
                    badge={faHexagonNodes}
                    style={{ cursor: 'pointer' }}
                  />
                  <div style={{ cursor: 'pointer' }}>
                    <h5>{entity.name}</h5>
                    <p>{entity.description || ''}</p>
                  </div>
                  <div style={{ 
  marginLeft: 'auto', 
  marginRight: '50px', 
  display: 'flex', 
  gap: '14px', 
  justifyContent:'space-between',
  alignItems: 'center' 
}}>

   <ToggleSwitch
              isLinked={checkIfPresent(entity.name)}
              onChange={() => linkUnlinkEntity(entity)}
            />
  <Button 
    style={{ 
      padding: '0.3rem 0.6rem', 
      fontSize: '0.8rem',
      minWidth: '90px' // Fixed width for Manage button
    }} 
    onClick={() => openEntityDrawer(entity, index)}
  >
    <FontAwesomeIcon icon={faGear} /> Manage
  </Button>
</div>
                </CardTitle>
              </Card>
            ))}
              <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalCount={totalItems}
                        setCurrentPage={setCurrentPage}
                        setTotalPages={setTotalPages}
                    />
          </>
        )}

        {/* Step 4: Validate */}
        {currentSetupStep === 4 && (
          <>
            <InfoBox>
              Validate your connections and ensure that the data sources are correctly linked to the Knowledgebase. This step allows you to verify that the data sources are accessible and that the entities are properly associated with the Knowledgebase.
            </InfoBox>
            <Divider />
            {knowledgeBaseDetail?.data_source && (
              <>
                {dataSource.map((ds, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} className={ds.status === "INACTIVE" ? "INACTIVE" : ""}>
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${ds.connector}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {ds.name}</h5>
                        <p>{ds.connectorDetails?.description || ''}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        {ds.validated ? <StatusBadge status={'active'}>Validated</StatusBadge> : <StatusBadge status={'inactive'}>Not Validated</StatusBadge>}

                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => verifyDs(ds, index)}><FontAwesomeIcon icon={faPlay} /> Test</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}
          </>
        )}

        {/* Step 5: Review */}
        {currentSetupStep === 5 && (
          <>
            <InfoBox>
              Review your knowledgebase configuration and ensure that all the data sources, entities, and connections are set up correctly.
            </InfoBox>
            <Divider />
            {knowledgeBaseDetail && (
              <>
                <Table>
                  <tbody>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Name</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.name}</td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Desciption</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.description}</td>
                    </TableRow>

                    <TableRow height={'30px'}>
                      <td width={'200px'}>Remove PII Data</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.pii_flag}</td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Data Sources</td>
                      <td width={'30px'}>:</td>
                      <td>
                        {dataSource.map((ds, index) => (
                          <TableRow height={'30px'} key={index}>
                            <td width={'200px'}>
                              {ds?.name}
                            </td>
                            <td>
                              {ds.validated ? <StatusBadge status={'active'}>Validated</StatusBadge> : <StatusBadge status={'inactive'}>Not Validated</StatusBadge>}
                            </td>
                            <td>
                              {ds.status == 'ACTIVE' ? <StatusBadge status={'active'}>Active</StatusBadge> : <StatusBadge status={'inactive'}>In-Active</StatusBadge>}
                            </td>
                          </TableRow>
                        ))}
                      </td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Entities</td>
                      <td width={'30px'}>:</td>
                      <td>
                        {renderEntity(knowledgeBaseDetail?.entities)}
                      </td>
                    </TableRow>

                  </tbody>
                </Table>

              </>
            )}
          </>
        )}


        <Footer>
          {currentSetupStep > 1 && (
            <Button
              onClick={() => setCurrentSetupStep(currentSetupStep - 1)}
              style={{ background: 'transparent', color: 'var(--primary)', border: '1px solid var(--primary)' }}
            >
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />  Previous
            </Button>
          )}

          <div style={{ flex: '1' }}></div>

          {currentSetupStep < 5 ? (
            <Button
              onClick={() => setCurrentSetupStep(currentSetupStep + 1)}
              style={{ minWidth: '100px' }}
            >
              Next <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </Button>
          ) : (
            (userAccessPermissions.includes(permissionEnum.CREATE) ||
              userAccessPermissions.includes(permissionEnum.UPDATE)) && (
              <Button primary onClick={() => saveKnowledgebase()}>
                <FontAwesomeIcon icon={faSave} /> Save Knowledgebase
              </Button>
            )
          )}
        </Footer>




      </motion.div>

      {/* Custom Drawer */}
      {isDrawerOpen && (
        <div className="custom-drawer">
          <div className="drawer-content">
            <SubSectionTitle>Data Source Details</SubSectionTitle>
            <Divider />
            {selectedDataSource && (
              <>
                <div style={{ paddingBottom: '50px' }}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input
                      type="text"
                      value={selectedDataSource.name || ''}
                      onChange={(e) =>
                        setSelectedDataSource({
                          ...selectedDataSource,
                          name: e.target.value,
                        })
                      }
                    />
                  </FormGroup>



                  {selectedDataSource.connectorDetails?.code == "Document" ? (
                    <>
                      {/* Drag-and-Drop Area */}
                      <div
                        {...getRootProps()}
                        style={{
                          border: '2px dashed #ccc',
                          borderRadius: '8px',
                          padding: '1rem',
                          textAlign: 'center',
                          marginTop: '1rem',
                          cursor: 'pointer',
                          backgroundColor: isDragActive ? '#f0f8ff' : '#fff',
                        }}
                      >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p>Drop the files here...</p>
                        ) : (
                          <p style={{ marginBottom: "0px" }}>Drag and drop files here, or click to select files <br /> <small>Maximum Files allowed at a time: {maxFiles}<br /> Files Types allowed:  {fileTypes.join(', ')} </small></p>
                        )}
                      </div>

                      {/* Display Uploaded Files */}
                      <div style={{ marginTop: '1rem' }}>
                        <SubSectionTitle>Uploaded Files:</SubSectionTitle>
                        <Divider />
                        <Table>
                          <thead>
                            <tr>
                              <TableHeader>Name</TableHeader>
                              <TableHeader>Last Updated </TableHeader>
                            </tr>
                          </thead>
                          <tbody>
                            {uploadedFiles.map((doc, index) => (
                              <TableRow key={index}>
                                <TableCell>{doc.file_name}</TableCell>
                                <TableCell>{formatDate(doc.updated_at)}</TableCell>
                              </TableRow>
                            ))}
                          </tbody>
                        </Table>

                      </div>
                    </>
                  ) : (
                    selectedDataSource.connectorDetails?.properties.map((ds, index) => (
                      <>
                        <FormGroup key={index}>
                          <Label>{formatString(ds)}</Label>
                          <Input
                            type="text"
                            value={selectedDataSource.data[ds] || ''}
                            onChange={(e) =>
                              setSelectedDataSource({
                                ...selectedDataSource,
                                data: {
                                  ...selectedDataSource.data,
                                  [ds]: e.target.value, // Update the specific property in the data object
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </>
                    ))
                  )}

                  {/* Custom Properties */}
                  <div>
                    <SubSectionTitle>Custom Properties:</SubSectionTitle>
                    <Divider />
                    <Table>
                      <thead>
                        <tr>
                          <TableHeader>Key</TableHeader>
                          <TableHeader>Value</TableHeader>
                          <TableHeader>Actions</TableHeader>
                        </tr>
                      </thead>
                      <tbody>
                        {getNonConnectorProperties().map((key, index) => (
                          <TableRow key={index}>
                            <TableCell>{key}</TableCell>
                            <TableCell>{selectedDataSource.data[key]}</TableCell>
                            <TableCell>
                              <Button
                                onClick={() => removeCustomProperty(key)}
                                style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}
                              >
                                Remove
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </tbody>
                    </Table>
                    <Divider />
                    <FormRowFull style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        type="text"
                        value={newKey}
                        placeholder='Key'
                        onChange={(e) => setNewKey(e.target.value)}
                      />
                      <Input
                        placeholder='Value'
                        type="text"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                      />
                      <Button primary style={{ marginTop: '0px' }}
                        onClick={() => {
                          if (newKey && newValue) {
                            addCustomProperty(newKey, newValue);
                            setNewKey('');
                            setNewValue('');
                          }
                        }}
                      >
                        Add
                      </Button>
                    </FormRowFull>
                  </div>
                  <FormRow>
                    <FormGroup>
                      <Label>Status</Label>
                      <Toggle>
                        <ToggleInput
                          type="checkbox"
                          checked={selectedDataSource.status === "ACTIVE"}
                          onChange={(e) => {
                            setSelectedDataSource({
                              ...selectedDataSource,
                              status: e.target.checked ? "ACTIVE" : "INACTIVE",
                            });
                          }}
                        />
                      </Toggle>
                    </FormGroup>
                  </FormRow>
                </div>
                <div style={{ display: 'flex',alignItems:'center', gap: '0.5rem', position: 'sticky', bottom: '0px', width: '100%', backgroundColor:"#f7f7ff", padding:'5px' }}>
            <Button
              onClick={() => saveDsChanges(selectedDataSource, selectedDataSourceIndex)}
            >
              Save
            </Button>
            <Button onClick={closeDrawer}>Cancel</Button>
          </div>
              </>
            )}
          </div>

          
        </div>
      )}

      {/* Custom Drawer */}
      {isEntityDrawerOpen && (
        <div className="custom-drawer entity-drawer">
          <div className="drawer-content">
            <SubSectionTitle>Entity Details</SubSectionTitle>
            <Divider />
            <Input type="text" placeholder="Search Attributes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Table>
              <thead>
                <tr>
                  <TableHeader>Name </TableHeader>
                  <TableHeader>Type</TableHeader>
                </tr>
              </thead>
              <tbody>
                {filteredAttributes.map((attrib, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {attrib?.name}
                    </TableCell>
                    <TableCell>
                      {getAttribType(attrib?.type)}
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </Table>

            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button onClick={() => linkUnlinkEntity(selectedEntity)} >
                {checkIfPresent(selectedEntity.name) ? "Unlink" : "Link"}
              </Button>
              <Button onClick={closeEntityDrawer}>Cancel</Button>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModal && (
        <Modal
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeModal}
        >
          <ModalContent onClick={e => e.stopPropagation()}>
            <SubSectionTitle>Add New Data Source to Knowledge Base</SubSectionTitle>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>Data Source Name</Label>
                <Input type="text" value={selectedDataSource?.name || ''} onChange={(e) => setSelectedDataSource({ ...selectedDataSource, name: e.target.value })} />
              </FormGroup>
            </FormRow>
            {connector && (
              <>
                {connector.map((conn, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} >
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${conn.code}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {conn.name}</h5>
                        <p>{conn.description}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => addDataSource(conn)}><FontAwesomeIcon icon={faPlus} /> Add</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}

          </ModalContent>
        </Modal>
      )}
    </PageContainer>
  );
}

export default KnowledgebaseDetails;